export default "__VITE_ASSET__Cwh6Ayr1__"